// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled{
  opacity: 0.5;
}
.product_details_box {
  padding: 3rem;
  display: flex;
  flex-direction: row;
  transition: all 0.5s ease-in-out;
}
.product_details_img img {
  object-fit: cover;
  width: 300px;
  height: 100%;
  box-shadow: -10px 0px 26px 3px rgba(0, 0, 0, 0.27);
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.product_details_info_box {
  padding: 2rem;
  box-shadow: 0px 0px 26px -5px rgba(0, 0, 0, 0.75);
  width: 100%;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.product_details_primary_info_box {
  display: flex;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.801);
  border-top-right-radius: 14px;
  border-top-left-radius: 14px;
  padding: 1rem;
  box-shadow: 0px 26px 41px -39px rgba(0, 0, 0, 0.75);
  margin-bottom: 3rem;
}
.product_details_name_box{
  font-weight: bold;
  color: var(--ColorSecondaryDark);
}
.product_details_description_box {
  opacity: 0.7;
  font-weight: bold;
}
.product_details_price_box:last-child {
  font-weight: bold;
  color: var(--ColorSecondaryDark);
}
.product_details_switch {
  margin-top: 4rem;
  margin-left: 33vmax;
}
.product_details_price_box {
  display: flex;
  gap: 0.4rem;
}

.product_details_category_box {
  display: flex;
  gap: 1rem;
}
.product_details_code_box {
  display: flex;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/productDetailsComponent/productDetailsComponent.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kDAAkD;EAClD,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,iDAAiD;EACjD,WAAW;EACX,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,4CAA4C;EAC5C,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,mDAAmD;EACnD,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".disabled{\n  opacity: 0.5;\n}\n.product_details_box {\n  padding: 3rem;\n  display: flex;\n  flex-direction: row;\n  transition: all 0.5s ease-in-out;\n}\n.product_details_img img {\n  object-fit: cover;\n  width: 300px;\n  height: 100%;\n  box-shadow: -10px 0px 26px 3px rgba(0, 0, 0, 0.27);\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n.product_details_info_box {\n  padding: 2rem;\n  box-shadow: 0px 0px 26px -5px rgba(0, 0, 0, 0.75);\n  width: 100%;\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n.product_details_primary_info_box {\n  display: flex;\n  justify-content: space-between;\n  background-color: rgba(255, 255, 255, 0.801);\n  border-top-right-radius: 14px;\n  border-top-left-radius: 14px;\n  padding: 1rem;\n  box-shadow: 0px 26px 41px -39px rgba(0, 0, 0, 0.75);\n  margin-bottom: 3rem;\n}\n.product_details_name_box{\n  font-weight: bold;\n  color: var(--ColorSecondaryDark);\n}\n.product_details_description_box {\n  opacity: 0.7;\n  font-weight: bold;\n}\n.product_details_price_box:last-child {\n  font-weight: bold;\n  color: var(--ColorSecondaryDark);\n}\n.product_details_switch {\n  margin-top: 4rem;\n  margin-left: 33vmax;\n}\n.product_details_price_box {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.product_details_category_box {\n  display: flex;\n  gap: 1rem;\n}\n.product_details_code_box {\n  display: flex;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
